export enum Quadrant {
	A1 = "A1",
    B1 = "B1",
    A2 = "A2",
    B2 = "B2"
}